
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "checklist",
  "title": "Launch Checklist",
  "sidebar_label": "Checklist"
};
const slug = 'checklist';
const tableOfContents = [{
  "title": "Checklist from stard to end on what you need to launch.",
  "slug": "checklist-from-stard-to-end-on-what-you-need-to-launch",
  "children": []
}, {
  "title": "For Developers",
  "slug": "for-developers",
  "children": []
}, {
  "title": "5 Steps for No Coders",
  "slug": "5-steps-for-no-coders",
  "children": []
}, {
  "title": "1. Selecting mandatory informations)",
  "slug": "1-selecting-mandatory-informations",
  "children": []
}, {
  "title": "2. Platform Fundamentals",
  "slug": "2-platform-fundamentals",
  "children": []
}, {
  "title": "3. Configure 3rd Party integrations",
  "slug": "3-configure-3rd-party-integrations",
  "children": []
}, {
  "title": "4. Customising your look and feel of the App",
  "slug": "4-customising-your-look-and-feel-of-the-app",
  "children": []
}, {
  "title": "5. Appstore / Playstore related informations",
  "slug": "5-appstore-playstore-related-informations",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <_Heading level={2} id={"checklist-from-stard-to-end-on-what-you-need-to-launch"} nextElement={{
      "type": "paragraph"
    }}>Checklist from stard to end on what you need to launch.</_Heading>
    <p>{`Tradly solution is catered to different groups separately`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`For developers: Headless API solution. Using the API solution, developers can build apps on top of it`}</li>
      <li parentName="ul">{`For non-coders: A simple toggle based SuperAdmin Panel to configure features in the already pre-built apps (also called as storefront, front end apps, templated apps).`}</li>
    </ul>
    <_Heading level={2} id={"for-developers"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>For Developers</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><_Link href="/signup" passHref><a>{`Signup for a free account`}</a></_Link></li>
      <li parentName="ul">{`Get the API keys in the SuperAdmin > Settings > API section`}</li>
      <li parentName="ul">{`Refer the `}<a parentName="li" {...{
          "href": "https://developer.tradly.app"
        }}>{`API Reference`}</a>{` to start building the app`}</li>
    </ul>
    <_Heading level={2} id={"5-steps-for-no-coders"} nextElement={{
      "type": "paragraph"
    }}>5 Steps for No Coders</_Heading>
    <p>{`⭐⭐⭐`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><_Link href="/signup" passHref><a>{`Signup for a free account`}</a></_Link></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://superadmin.tradly.app"
        }}>{`Prototype your app using our SuperAdmin builder`}</a></li>
      <li parentName="ul"><_Link href="/docs/testingapp" passHref><a>{`Visualise your app through test apps`}</a></_Link></li>
      <li parentName="ul">{`When you are ready to launch, Subscribe to our plans and get a white label app build or continue to use web apps.`}</li>
    </ul>
    <p>{`There will be 5 type of works you will be doing to configure the app to work fully functional for a MVP launch to the market.`}</p>
    <_Heading level={2} id={"1-selecting-mandatory-informations"} nextElement={{
      "type": "paragraph"
    }}>1. Selecting mandatory informations)</_Heading>
    <p>{`As of Nov 2022, When you signup as a new user, all the below items are activated with default values and you can change them in SuperAdmin.`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Default things (Example: Appname, currency, Language, registration method, country you want to launch, ) `}</li>
      <li parentName="ul">{`Choose your business Model (Product Marketplace, Service Marketplace, etc) `}</li>
      <li parentName="ul">{`Choose Revenue Model : See here for the available revenue model for your business and how it works`}</li>
      <li parentName="ul">{`Choose Delivery Method/Service Methods`}</li>
      <li parentName="ul">{`Choose Payment Gateways`}</li>
      <li parentName="ul">{`Choose Location & Map if you are planning to have location specific features`}</li>
    </ul>
    <p>{`NICE! When you reach the SuperAdmin home page, you will be able to find your APP NAME. That’s the APP NAME you should be using to experience your test app via Tradly Test apps. Whatever the type of marketplaces, mostly these are the fundamental blocks you should need to configure. The rest of the steps are mostly according to your business`}</p>
    <_Heading level={2} id={"2-platform-fundamentals"} nextElement={{
      "type": "paragraph"
    }}>2. Platform Fundamentals</_Heading>
    <p>{`You must configure this below things for the system to be able to open accounts, submit listings and make purchases.`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Configure accounts: SuperAdmin > Settings > accounts(categories, attributes)`}</li>
      <li parentName="ul">{`Configure listings: SuperAdmin > Settings > listings (Setting up listings information to be collected. Categories, attributes) `}</li>
      <li parentName="ul">{`Stripe/other payment gateways configuration (under native integrations) `}</li>
      <li parentName="ul">{`Configure revenue model, commissions: SuperAdmin > Settings > commissions OR Settings > Subscriptions OR Settings > Special Fees`}</li>
    </ul>
    <_Heading level={2} id={"3-configure-3rd-party-integrations"} nextElement={{
      "type": "paragraph"
    }}>3. Configure 3rd Party integrations</_Heading>
    <p>{`When you don’t setup this, below features may not work.`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Configure email if you want the emails to be whitelisted`}</li>
      <li parentName="ul">{`Configure domain if you want good deliverability of emails`}</li>
      <li parentName="ul">{`Chat setup via Firebase`}</li>
      <li parentName="ul">{`Optionally referral / sharing features via Branch`}</li>
      <li parentName="ul">{`Optionally later legal informations (privacy, terms, etc) `}</li>
    </ul>
    <p>{`:::important
This below information are applicable only if you need Tradly or it’s Partners to customise and launch your mobile apps. This is not for Headless API subscribers.
:::`}</p>
    <_Heading level={2} id={"4-customising-your-look-and-feel-of-the-app"} nextElement={{
      "type": "paragraph"
    }}>4. Customising your look and feel of the App</_Heading>
    <p>{`When you request a build from us, whatever the branding and customisation you have configured in mobile config (under SuperAdmin) will be available for you.`}</p>
    <p>{`Settings > App Customisation > add app related informations`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`App Name`}</li>
      <li parentName="ul">{`Choose your app colour `}</li>
      <li parentName="ul">{`App Icon`}</li>
      <li parentName="ul">{`Splash launch images `}</li>
      <li parentName="ul">{`Onboarding images , Onboarding Text`}</li>
      <li parentName="ul">{`Registration Text`}</li>
      <li parentName="ul">{`Sell Icon (optional) `}</li>
      <li parentName="ul">{`App title in Home Screen (Default will be app name)
And others`}</li>
    </ul>
    <_Heading level={2} id={"5-appstore-playstore-related-informations"} nextElement={{
      "type": "paragraph"
    }}>5. Appstore / Playstore related informations</_Heading>
    <p>{`If we are helping you to launch apps on playstore and appstore, we need the below things to be ready. For Appstore, we need appstore Developer level access to send the build to your account.`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Appstore access & Provisioning`}</li>
      <li parentName="ul">{`Playstore access & Provisioning`}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
